import * as React from 'react';
import { TransitionProps } from 'react-transition-group/Transition';
import { AppContextProvider } from '@store/context';
import Menu from '@components/Menu';
import { Transition } from "react-transition-group";
import ArrowNavigation from "@components/ArrowNavigation";
import classnames from 'classnames';
import { Portfolio, Blog, Navigating } from '@store/index';
import { Location } from 'history';
import { mobileOperatingSystem } from '@utils/ViewPort';
import { Helmet } from "react-helmet";
import DateUtils from '@utils/Date';
import './index.scss';

interface State {
    entered?: boolean;
    backShow: boolean;
    forwardShow: boolean;
    back?: Arrow;
    forward?: Arrow;
}

interface Props extends TransitionProps {
    portfolios: Portfolio[];
    blogs: Blog[];
    location: Location
}

interface Arrow {
    label: string;
    to: string;
    children?: boolean;
}

const urls: Arrow[] = [
    {label: 'Contact', to: '/contact'},
    {label: 'Blog', to: '/blog', children: true},
    {label: 'Skills', to: '/skills'},
    {label: 'Portfolio', to: '/portfolio', children: true},
    {label: 'About me', to: '/'},
];

class TransitionComponent extends React.PureComponent<Props, State> {
    private interval: number;
    private isDay = DateUtils.isDay();

    constructor(props: Props) {
        super(props);

        this.state = {
            entered: false,
            backShow: props.location.pathname !== '/',
            forwardShow: props.location.pathname !== '/contact',
            back: this.getNavigation(props.location.pathname, true),
            forward: this.getNavigation(props.location.pathname, false),
        }
    }

    private getNextNavigation = (
        items: Navigating[],
        back: boolean, 
        pathname: string, 
        current: Arrow,
        prevPath: string): Arrow | undefined => 
    {
        let porfolioIndex = items.findIndex((portfolio) => pathname.substr(prevPath.length) === portfolio.slug)
        const portfolio = items[(back ? --porfolioIndex : ++porfolioIndex)];
        if (portfolio) {
            return {label: portfolio.name, to:`${prevPath}${portfolio.slug}`}
        } else if (back) {
            return current;
        }
        return undefined
    }

    private getNavigation = (pathname: string, back: boolean): Arrow | undefined => {
        let index = urls.findIndex((u) => pathname.indexOf(u.to) > -1);
        const current = urls[index];
        if (!current) {
            return undefined;
        }

        if (current.to !== pathname.replace(/\/$/, '')) {
            // It means we get into subpage
            let navigation;
            if ('Portfolio' === current.label) {
                navigation = this.getNextNavigation(this.props.portfolios, back, pathname, current, '/portfolio/');
            } else if ('Blog' === current.label) {
                navigation = this.getNextNavigation(this.props.blogs, back, pathname, current, '/blog/');
            }
            if (navigation) {
                return navigation;
            }
        }

        if (urls[(back ? ++index : --index)]) {
            return urls[index];
        }
        
        return undefined;
    }

    public componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    render(): JSX.Element {
        const props = this.props;
        const { back, forward, backShow, forwardShow, entered } = this.state;
        const white = this.isDay && '/' === props.location.pathname;

        return (
            <Transition {...props} onEnter={() => this.setState({entered: true})} onEntered={() => this.setState({entered: false})}>
                <AppContextProvider value={{on: props.in}}>
                    <>
                        {
                            <Helmet
                                htmlAttributes={{
                                    class: classnames(mobileOperatingSystem)
                                }}
                            />
                        }
                        <Menu position="home" />
                        <div className={classnames({
                            'pt-page-moveToBottom': !props.in,
                            'pt-page-scaleUp': props.in,
                            'pt-ab': entered,
                        })}>
                            {this.props.children}
                        </div>
                        { backShow && back && <ArrowNavigation to={back.to} label={back.label} back={true} white={white} /> }
                        { forwardShow && forward && <ArrowNavigation to={forward.to} label={forward.label} white={white} /> }
                    </>
                </AppContextProvider>
            </Transition>
        )
    }
}

export default TransitionComponent;



// WEBPACK FOOTER //
// ./src/components/Transition/index.tsx